
import { navigate } from '@redwoodjs/router';

import Button from 'src/components/Button';
import { Flex } from 'src/components/Flex';
import { createColumnDef } from 'src/components/NPIDataGrid/NPIDataGrid.utils';
import { formatDate } from 'src/utils/utils';

export const commissionStatementsGridColDefs = () => {
    return [
        createColumnDef({
            field: 'commissionStatementId',
            headerName: 'ID',
        }),
        createColumnDef({
            field: 'partnerName',
            headerName: 'Partner Name',
        }),
        createColumnDef({
            field: 'totalCommission',
            headerName: 'Commission',
        }),
        createColumnDef({
            field: 'statementDate',
            headerName: 'Statement Date',
            align: 'center',
            renderCell: ({ row }) => {
                return (
                    <Flex alignItems={'center'} height={'100%'}>
                        {formatDate({ date: new Date(row.statementDate) })}
                    </Flex>
                );
            },
        }),
        createColumnDef({
            field: 'billingCycle',
            headerName: 'Billing Cycle',
        }),
        createColumnDef({
            field: 'selfBillingInvoiceId',
            headerName: 'Self-Billing Invoice',
            renderCell: ({ row }) => {
                const selfBillingInvoice = row?.selfBillingInvoice;
                return (
                    <Button
                        disabled={!selfBillingInvoice?.id}
                        variant="text"
                        onClick={(e) => {
                            e.stopPropagation();
                            if (selfBillingInvoice?.id) {
                                navigate(
                                    `/finance/self-billing-invoices/${selfBillingInvoice?.id}`
                                );
                            }
                        }}
                    >
                        {selfBillingInvoice?.sageInvoiceNumber}
                    </Button>
                );
            },
        })
    ];
};

export default commissionStatementsGridColDefs;
